const getTitleFromPath = (path: string, fieldNames: string[] | string): string => {
	if (!path) return '';

	const possibleFieldNames = typeof fieldNames === 'string' ? [fieldNames] : fieldNames;

	if (possibleFieldNames.every(field => !path.includes(field)) && !path.includes('/')) return path;

	const fieldNameOptions = `${possibleFieldNames.map(fieldName => `(${fieldName})`).join('|')}`;

	const fieldNameIncludingStringFollowingReg = new RegExp(`(${fieldNameOptions}).*`, 'g');
	const fieldNameRegex = new RegExp(fieldNameOptions);

	const beginningOfName = path.search(fieldNameIncludingStringFollowingReg);

	const fileName = path.slice(beginningOfName).split(fieldNameRegex).slice(possibleFieldNames.length + 1).join('');

	return fileName;
}

export default getTitleFromPath;